import { defineMessages } from 'react-intl';

import { CAMPAIGN_TYPE } from '../Campaigns.helpers';

export const messages = defineMessages({
  heading: {
    id: 'campaigns-confirmation-modal.heading',
    defaultMessage: 'Confirm campaign',
  },
  campaignType: {
    id: 'campaigns-confirmation-modal.campaign-type',
    defaultMessage: 'Campaign type',
  },
  services: {
    id: 'campaigns-confirmation-modal.services',
    defaultMessage: 'Services',
  },
  discountAmount: {
    id: 'campaigns-confirmation-modal.discount-amount',
    defaultMessage: 'Discount amount',
  },
  startDate: {
    id: 'campaigns-confirmation-modal.start-date',
    defaultMessage: 'Start date',
  },
  endDate: {
    id: 'campaigns-confirmation-modal.end-date',
    defaultMessage: 'End date',
  },
  discountPercentage: {
    id: 'campaigns-confirmation-modal.discount-percentage',
    defaultMessage: '{value}% discount',
  },
  disclaimerCreate: {
    id: 'campaigns-confirmation-modal.disclaimer',
    defaultMessage:
      'By clicking “Launch campaign”, you agree that payments to you will be discounted by the applicable percentage shown for any reservations booked through this campaign.',
  },
  disclaimerEdit: {
    id: 'campaigns-confirmation-modal.disclaimer-edit',
    defaultMessage:
      'By clicking “Confirm”, you agree that payments to you will be discounted by the applicable percentage shown for any reservations booked through this campaign.',
  },
  cancel: {
    id: 'campaigns-confirmation-modal.cancel',
    defaultMessage: 'Cancel',
  },
  launchCampaign: {
    id: 'campaigns-confirmation-modal.launch-campaign',
    defaultMessage: 'Launch campaign',
  },
  confirm: {
    id: 'campaigns-confirmation-modal.confirm',
    defaultMessage: 'Confirm',
  },
  allServices: {
    id: 'campaigns-confirmation-modal.all-services',
    defaultMessage: 'All services',
  },
  moreInformation: {
    id: 'campaigns-confirmation-modal.more-information',
    defaultMessage: 'More information',
  },
  classes: {
    id: 'campaigns-confirmation-modal.classes',
    defaultMessage: 'Classes',
  },
  allClasses: {
    id: 'campaigns-confirmation-modal.all-classes',
    defaultMessage: 'All classes',
  },
  items: {
    id: 'campaigns-confirmation-modal.items',
    defaultMessage: 'Items',
  },
  allItems: {
    id: 'campaigns-confirmation-modal.all-items',
    defaultMessage: 'All items',
  },
  schedule: {
    id: 'campaigns-confirmation-modal.schedule',
    defaultMessage: 'Schedule',
  },
});

export const campaignsTooltipsMessages = defineMessages({
  [CAMPAIGN_TYPE.ALL_USER]: {
    id: 'campaigns-confirmation-modal.tooltip-all-user',
    defaultMessage:
      'General promotion for all members. If more than one promotion applies a member will see the largest discount',
  },
  [CAMPAIGN_TYPE.NEW_USER]: {
    id: 'campaigns-confirmation-modal.tooltip-new-user',
    defaultMessage:
      'Attract new members to your venue by providing a discount on their first reservation at your venue',
  },
  [CAMPAIGN_TYPE.WINBACK]: {
    id: 'campaigns-confirmation-modal.tooltip-winback',
    defaultMessage:
      'Incentivize members to return to your venue by providing a discount to users who have not attended a class at your venue in at least 3 months',
  },
  [CAMPAIGN_TYPE.TIME_SLOT_ALL_USER]: {
    id: 'campaigns-confirmation-modal.tooltip-time-slot-all-user',
    defaultMessage:
      'Offer a discount only during the specific days and times you choose, to help fill your slower time slots',
  },
});
